import { ZCodeDto } from '@act/shared/data-transfer-objects';
import { ColumnConfiguration } from '@act/storybook';

export const NeedsZcodesTableColumns = (): ColumnConfiguration<ZCodeDto>[] => [
  {
    id: 'label',
    value: 'label',
    isNumeric: false,
    shouldDisablePadding: false,
    sortable: true,
    title: 'Label',
  },
  {
    id: 'key',
    value: 'key',
    isNumeric: false,
    shouldDisablePadding: false,
    title: 'Key',
  },
  {
    id: 'overview',
    value: 'overview',
    isNumeric: false,
    shouldDisablePadding: false,
    title: 'Overview',
  },
  {
    id: 'issues',
    value: (row: ZCodeDto) => {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          {row.issues.map((issue, index) => (
            <div key={index}>
              {issue}
              {index < row.issues.length - 1 ? ',' : '.'}
            </div>
          ))}
        </div>
      );
    },
    isNumeric: false,
    shouldDisablePadding: false,
    title: 'Issues',
  },
  {
    id: 'assistances',
    value: (row: ZCodeDto) => {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          {row.assistances.map((assistance, index) => (
            <div key={index}>
              {assistance}
              {index < row.assistances.length - 1 ? ',' : '.'}
            </div>
          ))}
        </div>
      );
    },
    isNumeric: false,
    shouldDisablePadding: false,
    title: 'Assistances',
  },
];
